const IntegradorSgl = [
  {
    value: 'RV',
    text: 'RV',
  },
  {
    value: 'SOFTWARE_EXPRESS',
    text: 'Software Express',
  },
  {
    value: 'TENDENCIA',
    text: 'Tendência',
  },
  {
    value: 'TELEIN',
    text: 'Tele In',
  },
  {
    value: 'EPAY',
    text: 'Epay',
  },
];

export default IntegradorSgl;
